import { createContext, useState, useEffect } from "react";
import packageInfo from "../../package.json";
import { GetCartItems, GetCartCount } from "../Data";

// Create context
export const cartContext = createContext();

// Create provider
export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  // Function to fetch cart count using the new API
  const GetCartItemsAsync = async () => {
    try {
      const userId = localStorage.getItem('userID');
      if (!userId) {
        setCartCount(0);
        return;
      }

      const response = await GetCartCount(userId);
      
      if (response && response.success) {
        setCartCount(response.data || 0);
      } else {
        console.error("Failed to fetch cart count:", response.errors);
        setCartCount(0);
      }
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartCount(0);
    }
  };

  // Get items from local storage when page loads
  useEffect(() => {
    const itemCount = localStorage.getItem('itemCount');
    setCartCount(itemCount ? parseInt(itemCount) : 0);
  }, []);

  // Function to update cart count
  const updateCartCount = (count) => {
    setCartCount(count);
    localStorage.setItem('itemCount', count);
  };

  // Function to add item to cart (for compatibility)
  const addItemToCart = async (cartItem) => {
    try {
      // This is a simplified version - in a full implementation, 
      // you might want to call AddCartItems API here
      console.log('Adding item to cart:', cartItem);
      // For now, just refresh cart count
      await GetCartItemsAsync();
    } catch (error) {
      console.error('Error adding item to cart:', error);
    }
  };

  return (
    <cartContext.Provider value={{ cartCount, updateCartCount, GetCartItemsAsync, addItemToCart }}>
      {children}
    </cartContext.Provider>
  );
};
